import React, { Component } from 'react'
import {
    Alert, Button, Checkbox, Collapse, Drawer, Form, Input, InputNumber, message, Modal, Radio, Select, Space, Spin, Table, Tag, Typography
} from 'antd'
import {
    CopyOutlined, DatabaseOutlined, DeleteOutlined, FileTextOutlined, PlusOutlined, SearchOutlined, SettingOutlined
} from '@ant-design/icons'
import {
    createVibeAdminApp,
    deleteVibeAdminApp,
    getVibeAdminAppDetail,
    getVibeAdminDepartments,
    getVibeAdminAppList,
    getVibeAdminProjectTableData,
    getVibeAdminProjectTables,
    getVibeDbPromptTemplate,
    getVibeMysqlConnectionList,
    getUserListForDropbox,
    resetVibeDbPromptTemplate,
    saveVibeMysqlConnection,
    saveVibeDbPromptTemplate,
    syncAllVibeAdminDatabaseReadme,
} from '../../request'
import VibeAppDetailDrawer from './VibeAppDetailDrawer'

const { Paragraph, Text } = Typography
const { Panel } = Collapse
const { Option } = Select

const STATUS_MAP = {
    approved: { text: '待部署', color: 'processing' },
    provisioning: { text: '接入中', color: 'processing' },
    ready: { text: '已就绪', color: 'success' },
    failed: { text: '失败', color: 'error' },
    disabled: { text: '禁用', color: 'default' },
    deleted: { text: '已删除', color: 'default' },
}

const DEPLOYMENT_MODE_META = {
    server: { text: '服务器部署', color: 'blue' },
    local: { text: '仅本地运行', color: 'default' },
}

const BUSINESS_SUBJECT_META = {
    lechun: { text: '乐纯', color: 'green' },
    superbody: { text: '超体', color: 'orange' },
}

const LEGACY_DEPLOY_PROMPT_INTRO = '请在你的业务项目目录里，把下面说明粘贴给 Codex 执行初始化。'
const DEPLOY_PROMPT_INTRO = `你现在要帮我初始化一个公司 VibeCoding 服务器部署项目。

这个项目需要部署到公司服务器上，通过 GitLab CI 构建 Docker 镜像，并发布到指定访问地址。`

export default class VibeAppManagement extends Component {
    appFormRef = React.createRef()
    connectionFormRef = React.createRef()

    state = {
        dataSource: [],
        pagination: { current: 1, pageSize: 20, total: 0 },
        keyword: '',
        status: undefined,
        dingdingDeptId: undefined,
        dingdingDepartments: [],
        loading: false,
        detailVisible: false,
        detailProjectId: null,
        batchSyncing: false,
        dataVisible: false,
        dataProject: null,
        tableKeyword: '',
        tableLoading: false,
        tableList: [],
        selectedTableName: '',
        dataKeyword: '',
        dataFilterColumn: undefined,
        dataFilterOperator: 'contains',
        dataFilterValue: '',
        tableDataLoading: false,
        tableColumns: [],
        tableRows: [],
        tableLastDataTime: null,
        tableDataPagination: { current: 1, pageSize: 30, total: 0 },
        users: [],
        mysqlConnections: [],
        appCreateVisible: false,
        appCreating: false,
        connectionManageVisible: false,
        connectionEditVisible: false,
        connectionSaving: false,
        editingConnection: null,
        promptTemplateVisible: false,
        promptTemplateLoading: false,
        promptTemplateSaving: false,
        promptTemplateText: '',
        promptTemplateCustomized: false,
        deletingProjectId: null,
        projectPromptVisible: false,
        projectPromptLoading: false,
        projectPromptName: '',
        projectPromptMode: 'server',
        projectPromptText: '',
    }

    componentDidMount() {
        this.loadList()
        this.loadDepartments()
        this.loadUsers()
        this.loadMysqlConnections()
    }

    loadUsers = () => getUserListForDropbox({ type: 0 })
        .then(res => this.setState({ users: res || [] }))
        .catch(() => {})

    loadDepartments = () => getVibeAdminDepartments({})
        .then(res => this.setState({ dingdingDepartments: res || [] }))
        .catch(() => {})

    loadMysqlConnections = () => getVibeMysqlConnectionList({})
        .then(res => this.setState({ mysqlConnections: res || [] }))
        .catch(() => {})

    normalizePromptText = text => {
        if (!text) return ''
        return text.replace(/\\r\\n/g, '\n').replace(/\\n/g, '\n').replace(/\\r/g, '\n')
    }

    // 2026-07-20 coder(lq): Reuse the authorization page template so both admin entrances edit one shared prompt.
    openPromptTemplate = () => {
        this.setState({
            promptTemplateVisible: true,
            promptTemplateLoading: true,
            promptTemplateText: '',
            promptTemplateCustomized: false,
        })
        getVibeDbPromptTemplate()
            .then(res => this.setState({
                promptTemplateText: this.normalizePromptText(res?.prompt || ''),
                promptTemplateCustomized: !!res?.customized,
            }))
            .catch(() => {})
            .finally(() => this.setState({ promptTemplateLoading: false }))
    }

    savePromptTemplate = () => {
        const { promptTemplateText } = this.state
        if (!promptTemplateText || !promptTemplateText.trim()) {
            message.warning('问数提示词不能为空')
            return
        }
        this.setState({ promptTemplateSaving: true })
        saveVibeDbPromptTemplate({ prompt: promptTemplateText })
            .then(() => {
                message.success('问数提示词已保存')
                this.setState({ promptTemplateVisible: false })
            })
            .catch(() => {})
            .finally(() => this.setState({ promptTemplateSaving: false }))
    }

    resetPromptTemplate = () => {
        Modal.confirm({
            title: '恢复默认问数提示词？',
            content: '恢复后会删除后台维护的自定义内容，后续将使用系统内置默认版本。',
            okText: '恢复默认',
            onOk: () => resetVibeDbPromptTemplate().then(() => {
                message.success('已恢复默认问数提示词')
                this.openPromptTemplate()
            }),
        })
    }

    openCreateApp = () => {
        this.setState({ appCreateVisible: true }, () => {
            this.appFormRef.current?.resetFields()
            this.appFormRef.current?.setFieldsValue({
                deploymentMode: 'server',
                businessSubject: 'lechun',
                skipDatabaseCreation: true,
            })
        })
    }

    submitCreateApp = () => {
        this.appFormRef.current.validateFields().then(values => {
            this.setState({ appCreating: true })
            createVibeAdminApp(values).then(() => {
                message.success('应用已创建')
                this.setState({ appCreateVisible: false })
                this.loadList(1)
            }).catch(() => {})
                .finally(() => this.setState({ appCreating: false }))
        }).catch(() => {})
    }

    openCreateConnection = () => {
        this.setState({ connectionEditVisible: true, editingConnection: null })
    }

    openEditConnection = record => {
        this.setState({ connectionEditVisible: true, editingConnection: record })
    }

    getConnectionFormValues = () => this.connectionFormRef.current.validateFields()
        .then(values => ({ ...values, id: this.state.editingConnection?.id }))

    saveConnection = () => {
        this.getConnectionFormValues().then(values => {
            this.setState({ connectionSaving: true })
            saveVibeMysqlConnection(values).then(() => {
                message.success('数据库连接已保存')
                this.setState({ connectionEditVisible: false })
                this.loadMysqlConnections()
            }).catch(() => {})
                .finally(() => this.setState({ connectionSaving: false }))
        }).catch(() => {})
    }

    loadList = (pageNum = this.state.pagination.current, pageSize = this.state.pagination.pageSize) => {
        const { keyword, status, dingdingDeptId } = this.state
        this.setState({ loading: true })
        return getVibeAdminAppList({ pageNum, pageSize, keyword, status, dingdingDeptId })
            .then(res => {
                const page = res || {}
                this.setState({
                    dataSource: page.list || [],
                    pagination: {
                        current: page.pageNum || pageNum,
                        pageSize: page.pageSize || pageSize,
                        total: page.total || 0,
                    },
                })
            })
            .catch(() => {})
            .finally(() => this.setState({ loading: false }))
    }

    deleteApp = record => {
        Modal.confirm({
            title: `确认删除应用“${record.projectName || record.projectSlug || record.id}”？`,
            content: '删除后应用将不再显示，相关数据库授权会被撤销；不会删除 GitLab 项目和业务数据库。',
            okText: '删除',
            okButtonProps: { danger: true },
            onOk: () => {
                this.setState({ deletingProjectId: record.id })
                return deleteVibeAdminApp({ id: record.id })
                    .then(() => {
                        message.success('应用已删除')
                        return this.loadList()
                    })
                    .finally(() => this.setState({ deletingProjectId: null }))
            },
        })
    }

    openDetail = (record) => {
        this.setState({ detailVisible: true, detailProjectId: record.id })
    }

    openProjectPrompt = record => {
        this.setState({
            projectPromptVisible: true,
            projectPromptLoading: true,
            projectPromptName: record.projectName || record.projectSlug || '',
            projectPromptMode: this.getDeploymentMode(record),
            projectPromptText: '',
        })
        getVibeAdminAppDetail({ id: record.id })
            .then(detail => {
                // 2026-07-20 coder(lq): Local and server projects use different project-specific initialization flows.
                const prompt = this.getDeploymentMode(detail) === 'local'
                    ? detail?.localInitInstructionMd
                    : detail?.initInstructionMd
                this.setState({
                    projectPromptMode: this.getDeploymentMode(detail),
                    projectPromptText: this.normalizeProjectPromptText(prompt || ''),
                })
            })
            .catch(() => {})
            .finally(() => this.setState({ projectPromptLoading: false }))
    }

    normalizeProjectPromptText = text => this.normalizePromptText(text)
        .replace(/\\"/g, '"')
        .replace(LEGACY_DEPLOY_PROMPT_INTRO, DEPLOY_PROMPT_INTRO)

    copyProjectPrompt = () => {
        const { projectPromptText } = this.state
        if (!projectPromptText) {
            message.warning('当前应用暂无初始化提示词')
            return
        }
        if (!navigator.clipboard) {
            message.warning('当前浏览器不支持自动复制，请手动选择复制')
            return
        }
        navigator.clipboard.writeText(projectPromptText).then(() => message.success('初始化提示词已复制'))
    }

    syncAllDatabaseReadme = () => {
        Modal.confirm({
            title: '确认批量同步数据字典？',
            content: '将从各应用 GitLab 项目根目录读取 DATA_DICTIONARY.md 并写入应用表，单个应用失败不会影响其他应用。',
            okText: '同步',
            onOk: () => {
                this.setState({ batchSyncing: true })
                return syncAllVibeAdminDatabaseReadme({})
                    .then(res => {
                        const total = res?.total || 0
                        const success = res?.success || 0
                        const failed = res?.failed || 0
                        if (failed > 0) {
                            message.warning(`批量同步完成：成功 ${success} 个，失败 ${failed} 个，共 ${total} 个`)
                        } else {
                            message.success(`批量同步完成：成功 ${success} 个，共 ${total} 个`)
                        }
                        this.loadList()
                    })
                    .catch(() => {})
                    .finally(() => this.setState({ batchSyncing: false }))
            },
        })
    }

    openDataDrawer = (record) => {
        this.setState({
            dataVisible: true,
            dataProject: record,
            tableKeyword: '',
            tableLoading: false,
            tableList: [],
            selectedTableName: '',
            dataKeyword: '',
            dataFilterColumn: undefined,
            dataFilterOperator: 'contains',
            dataFilterValue: '',
            tableDataLoading: false,
            tableColumns: [],
            tableRows: [],
            tableLastDataTime: null,
            tableDataPagination: { current: 1, pageSize: 30, total: 0 },
        }, () => this.loadProjectTables())
    }

    loadProjectTables = (keyword = this.state.tableKeyword) => {
        const { dataProject } = this.state
        if (!dataProject?.id) return Promise.resolve()
        this.setState({ tableLoading: true, tableKeyword: keyword })
        return getVibeAdminProjectTables({ projectId: dataProject.id, keyword })
            .then(res => {
                const tables = res?.tables || []
                const selectedExists = tables.some(item => item.tableName === this.state.selectedTableName)
                this.setState({ tableList: tables })
                if (tables.length && !selectedExists) {
                    this.selectTable(tables[0].tableName)
                } else if (!tables.length) {
                    this.setState({
                        selectedTableName: '',
                        dataKeyword: '',
                        dataFilterColumn: undefined,
                        dataFilterOperator: 'contains',
                        dataFilterValue: '',
                        tableColumns: [],
                        tableRows: [],
                        tableLastDataTime: null,
                        tableDataPagination: { current: 1, pageSize: 30, total: 0 },
                    })
                }
            })
            .catch(() => {})
            .finally(() => this.setState({ tableLoading: false }))
    }

    selectTable = (tableName) => {
        if (!tableName) return
        this.setState({
            selectedTableName: tableName,
            dataKeyword: '',
            dataFilterColumn: undefined,
            dataFilterOperator: 'contains',
            dataFilterValue: '',
            tableRows: [],
            tableColumns: [],
            tableLastDataTime: null,
            tableDataPagination: { ...this.state.tableDataPagination, current: 1 },
        }, () => this.loadTableData(1, this.state.tableDataPagination.pageSize, ''))
    }

    loadTableData = (
        pageNum = this.state.tableDataPagination.current,
        pageSize = this.state.tableDataPagination.pageSize,
        keyword = this.state.dataKeyword,
        filterColumn = this.state.dataFilterColumn,
        filterOperator = this.state.dataFilterOperator,
        filterValue = this.state.dataFilterValue,
    ) => {
        const { dataProject, selectedTableName } = this.state
        if (!dataProject?.id || !selectedTableName) return Promise.resolve()
        this.setState({
            tableDataLoading: true,
            dataKeyword: keyword,
            dataFilterColumn: filterColumn,
            dataFilterOperator: filterOperator,
            dataFilterValue: filterValue,
        })
        return getVibeAdminProjectTableData({
            projectId: dataProject.id,
            tableName: selectedTableName,
            keyword,
            filterColumn,
            filterOperator,
            filterValue,
            pageNum,
            pageSize,
        }).then(res => {
            this.setState({
                tableColumns: res?.columns || [],
                tableRows: (res?.rows || []).map((item, index) => ({ ...item, __rowKey: `${pageNum}-${index}` })),
                tableLastDataTime: res?.lastDataTime || null,
                tableDataPagination: {
                    current: res?.pageNum || pageNum,
                    pageSize: res?.pageSize || pageSize,
                    total: res?.total || 0,
                },
            })
        }).catch(() => {})
            .finally(() => this.setState({ tableDataLoading: false }))
    }

    renderStatus = (status, project) => {
        if (status === 'approved' && this.getDeploymentMode(project) === 'local') {
            return <Tag color="processing">待初始化</Tag>
        }
        const meta = STATUS_MAP[status] || { text: status || '-', color: 'default' }
        return <Tag color={meta.color}>{meta.text}</Tag>
    }

    getDeploymentMode = (project) => project?.deploymentMode === 'local' ? 'local' : 'server'

    getBusinessSubject = (project) => project?.businessSubject === 'superbody' ? 'superbody' : 'lechun'

    renderDeploymentMode = (project) => {
        const meta = DEPLOYMENT_MODE_META[this.getDeploymentMode(project)]
        return <Tag color={meta.color}>{meta.text}</Tag>
    }

    renderBusinessSubject = (project) => {
        const meta = BUSINESS_SUBJECT_META[this.getBusinessSubject(project)]
        return <Tag color={meta.color}>{meta.text}</Tag>
    }

    formatCount = value => value === null || value === undefined
        ? '-'
        : String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    formatDictionaryError = error => {
        if (!error) return ''
        return String(error).includes('404 Not Found') ? '字典文件未提交' : error
    }

    getUserValue = item => item.userId || item.USER_ID || item.user_id || item.id || item.value

    getUserLabel = item => {
        const name = item.userNick || item.USER_NICK || item.user_nick || item.nick || item.label || ''
        const account = item.userName || item.USER_NAME || item.user_name || item.name || item.email || this.getUserValue(item)
        return name && account && name !== account ? `${name}（${account}）` : (name || account || '-')
    }

    getDepartmentRowSpan = index => {
        const { dataSource } = this.state
        const department = dataSource[index]?.dingdingDeptNames || '未设置部门'
        if (index > 0 && (dataSource[index - 1]?.dingdingDeptNames || '未设置部门') === department) return 0
        let rowSpan = 1
        while (index + rowSpan < dataSource.length
            && (dataSource[index + rowSpan]?.dingdingDeptNames || '未设置部门') === department) {
            rowSpan += 1
        }
        return rowSpan
    }

    renderColumns = () => [
        {
            title: '应用',
            key: 'project',
            width: 260,
            render: (_, record) => (
                <div>
                    <Space size={6} style={{ marginBottom: 6, flexWrap: 'wrap' }}>
                        <Text strong>{record.projectName || '-'}</Text>
                        <Text code style={{ fontSize: 12 }}>{record.projectSlug || '-'}</Text>
                    </Space>
                    <div><Text type="secondary">{record.description || '暂无描述'}</Text></div>
                </div>
            ),
        },
        {
            title: '所属用户',
            key: 'owner',
            width: 180,
            render: (_, record) => (
                <div>
                    <div>{record.ownerUserNick || record.ownerUserName || '-'}</div>
                    <Text type="secondary" style={{ fontSize: 12 }}>{record.ownerUserName || record.ownerUserId || '-'}</Text>
                </div>
            ),
        },
        {
            title: '钉钉部门',
            dataIndex: 'dingdingDeptNames',
            width: 190,
            render: (value, _, index) => ({
                children: <Text>{value || '未设置部门'}</Text>,
                props: { rowSpan: this.getDepartmentRowSpan(index) },
            }),
        },
        {
            title: '状态',
            dataIndex: 'status',
            width: 100,
            render: this.renderStatus,
        },
        {
            title: '类型 / 主体',
            key: 'metadata',
            width: 150,
            render: (_, record) => (
                <Space direction="vertical" size={4}>
                    {this.renderDeploymentMode(record)}
                    {this.renderBusinessSubject(record)}
                </Space>
            ),
        },
        {
            title: '数据库',
            key: 'database',
            width: 220,
            render: (_, record) => (
                <div>
                    <Text code>{record.mysqlDatabaseName || '-'}</Text>
                    {record.mysqlConnectionName ? (
                        <div style={{ marginTop: 4 }}><Text type="secondary">{record.mysqlConnectionName}</Text></div>
                    ) : null}
                    <div style={{ marginTop: 4 }}>
                        <Text type="secondary" style={{ fontSize: 12 }}>{record.mysqlHost || '-'}:{record.mysqlPort || '-'}</Text>
                    </div>
                    <div style={{ marginTop: 4 }}>{record.mysqlDatabaseStatus ? <Tag>{record.mysqlDatabaseStatus}</Tag> : null}</div>
                </div>
            ),
        },
        {
            title: '表数量',
            dataIndex: 'databaseTableCount',
            width: 100,
            render: (value, record) => record.databaseStatsError
                ? <Text type="danger" title={record.databaseStatsError}>获取失败</Text>
                : this.formatCount(value),
        },
        {
            title: '数据量（估算）',
            dataIndex: 'databaseRowCount',
            width: 130,
            render: (value, record) => record.databaseStatsError
                ? <Text type="danger" title={record.databaseStatsError}>获取失败</Text>
                : value === null || value === undefined ? '-' : `约 ${this.formatCount(value)}`,
        },
        {
            title: '部署',
            key: 'deploy',
            width: 240,
            render: (_, record) => this.getDeploymentMode(record) === 'local' ? (
                <Text type="secondary">仅本地运行，无服务器</Text>
            ) : (
                    <div>
                        <div>{record.deployHostName || '-'}</div>
                        <Paragraph style={{ marginBottom: 0 }} ellipsis={{ rows: 1 }} copyable={record.publicUrl ? { text: record.publicUrl } : false}>
                            <Text type="secondary">{record.publicUrl || '-'}</Text>
                        </Paragraph>
                    </div>
                ),
        },
        {
            title: '字典同步',
            key: 'dictionary',
            width: 230,
            render: (_, record) => {
                const contentLength = Number(record.databaseReadmeLength) || 0
                return (
                    <div>
                        <Space size={6}>
                            <Tag color={contentLength > 0 ? 'success' : 'error'}>
                                {contentLength > 0 ? '已有内容' : '暂无内容'}
                            </Tag>
                            {contentLength > 0 ? <Text type="secondary" style={{ fontSize: 12 }}>{contentLength} 字符</Text> : null}
                        </Space>
                        <div style={{ marginTop: 4 }}>
                            <Text type="secondary" style={{ fontSize: 12 }}>
                                数据更新：{record.databaseReadmeSyncedAt || '-'}
                            </Text>
                        </div>
                        {contentLength <= 0 && record.databaseReadmeError ? (
                            <Paragraph type="danger" style={{ fontSize: 12, marginBottom: 0 }} ellipsis={{ rows: 2 }}>
                                {this.formatDictionaryError(record.databaseReadmeError)}
                            </Paragraph>
                        ) : null}
                    </div>
                )
            },
        },
        {
            title: '操作',
            key: 'action',
            fixed: 'right',
            width: 340,
            render: (_, record) => (
                <Space size={8} wrap>
                    <Button size="small" type="primary" ghost onClick={() => this.openDetail(record)}>详情</Button>
                    <Button size="small" icon={<DatabaseOutlined />} onClick={() => this.openDataDrawer(record)}>数据</Button>
                    <Button size="small" icon={<FileTextOutlined />} onClick={() => this.openProjectPrompt(record)}>提示词</Button>
                    <Button
                        size="small"
                        danger
                        icon={<DeleteOutlined />}
                        loading={this.state.deletingProjectId === record.id}
                        disabled={record.status === 'provisioning'}
                        title={record.status === 'provisioning' ? '应用正在接入中，暂时不能删除' : '删除应用'}
                        onClick={() => this.deleteApp(record)}
                    >
                        删除
                    </Button>
                </Space>
            ),
        },
    ]

    renderDataDrawer = () => {
        const {
            dataVisible,
            dataProject,
            tableKeyword,
            tableLoading,
            tableList,
            selectedTableName,
            dataKeyword,
            dataFilterColumn,
            dataFilterOperator,
            dataFilterValue,
            tableDataLoading,
            tableColumns,
            tableRows,
            tableLastDataTime,
            tableDataPagination,
        } = this.state
        const visibleTableColumns = tableColumns.filter(column => String(column.columnName).toLowerCase() !== 'id')
        const dataColumns = [
            {
                title: '序号',
                key: '__index',
                width: 70,
                fixed: 'left',
                render: (value, record, index) => ((tableDataPagination.current || 1) - 1) * (tableDataPagination.pageSize || 30) + index + 1,
            },
            ...visibleTableColumns.map(column => ({
                title: (
                    <div>
                        <div>{column.columnName}</div>
                        {column.columnComment ? <Text type="secondary" style={{ fontSize: 12 }}>{column.columnComment}</Text> : null}
                    </div>
                ),
                dataIndex: column.columnName,
                key: column.columnName,
                width: 160,
                ellipsis: true,
                render: value => value === null || value === undefined ? <Text type="secondary">NULL</Text> : String(value),
            })),
        ]
        return (
            <Drawer
                title={dataProject ? `项目数据：${dataProject.projectName || dataProject.projectSlug}` : '项目数据'}
                visible={dataVisible}
                width="92%"
                onClose={() => this.setState({ dataVisible: false })}
                destroyOnClose
                bodyStyle={{ height: 'calc(100vh - 55px)', overflow: 'hidden' }}
            >
                <div style={{ display: 'flex', gap: 16, height: '100%', minHeight: 0 }}>
                    <div style={{ width: 300, borderRight: '1px solid #edf0f5', paddingRight: 12, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                        <Input.Search
                            allowClear
                            placeholder="筛选表"
                            value={tableKeyword}
                            onChange={e => this.setState({ tableKeyword: e.target.value })}
                            onSearch={value => this.loadProjectTables(value)}
                            style={{ marginBottom: 12 }}
                        />
                        <Table
                            rowKey="tableName"
                            size="small"
                            loading={tableLoading}
                            dataSource={tableList}
                            pagination={false}
                            scroll={{ y: 'calc(100vh - 195px)' }}
                            rowClassName={record => record.tableName === selectedTableName ? 'ant-table-row-selected' : ''}
                            onRow={record => ({ onClick: () => this.selectTable(record.tableName) })}
                            columns={[
                                {
                                    title: '表',
                                    dataIndex: 'tableName',
                                    render: (value, record) => (
                                        <div>
                                            <Text strong={value === selectedTableName}>{value}</Text>
                                            {record.tableComment ? <div><Text type="secondary" style={{ fontSize: 12 }}>{record.tableComment}</Text></div> : null}
                                        </div>
                                    ),
                                },
                            ]}
                        />
                    </div>
                    <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                            <Space>
                                <Text strong>{selectedTableName || '请选择表'}</Text>
                                {dataProject?.mysqlDatabaseName ? <Text code>{dataProject.mysqlDatabaseName}</Text> : null}
                                {selectedTableName ? (
                                    <Text type="secondary">最后数据上传时间：{tableLastDataTime || '暂无时间字段'}</Text>
                                ) : null}
                            </Space>
                            <Space wrap style={{ justifyContent: 'flex-end' }}>
                                <Input.Search
                                    allowClear
                                    placeholder="全表关键字"
                                    value={dataKeyword}
                                    onChange={e => this.setState({ dataKeyword: e.target.value })}
                                    onSearch={value => this.loadTableData(1, tableDataPagination.pageSize, value)}
                                    style={{ width: 210 }}
                                    disabled={!selectedTableName}
                                />
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder="选择字段"
                                    value={dataFilterColumn}
                                    optionFilterProp="children"
                                    style={{ width: 190 }}
                                    disabled={!selectedTableName}
                                    onChange={value => this.setState({ dataFilterColumn: value })}
                                >
                                    {visibleTableColumns.map(column => (
                                        <Option key={column.columnName} value={column.columnName}>
                                            {column.columnComment ? `${column.columnName} / ${column.columnComment}` : column.columnName}
                                        </Option>
                                    ))}
                                </Select>
                                <Select
                                    value={dataFilterOperator}
                                    style={{ width: 100 }}
                                    disabled={!selectedTableName || !dataFilterColumn}
                                    onChange={value => this.setState({ dataFilterOperator: value })}
                                >
                                    <Option value="contains">包含</Option>
                                    <Option value="eq">等于</Option>
                                    <Option value="startsWith">开头是</Option>
                                    <Option value="endsWith">结尾是</Option>
                                    <Option value="gt">大于</Option>
                                    <Option value="gte">大于等于</Option>
                                    <Option value="lt">小于</Option>
                                    <Option value="lte">小于等于</Option>
                                </Select>
                                <Input.Search
                                    allowClear
                                    placeholder="字段值"
                                    value={dataFilterValue}
                                    onChange={e => this.setState({ dataFilterValue: e.target.value })}
                                    onSearch={value => this.loadTableData(1, tableDataPagination.pageSize, dataKeyword, dataFilterColumn, dataFilterOperator, value)}
                                    style={{ width: 190 }}
                                    disabled={!selectedTableName || !dataFilterColumn}
                                />
                            </Space>
                        </div>
                        <Table
                            rowKey="__rowKey"
                            size="small"
                            loading={tableDataLoading}
                            dataSource={tableRows}
                            columns={dataColumns}
                            scroll={{ x: Math.max(70 + visibleTableColumns.length * 160, 900), y: 'calc(100vh - 250px)' }}
                            pagination={{
                                ...tableDataPagination,
                                pageSize: 30,
                                showSizeChanger: false,
                                showTotal: (total, range) => `${range[0]}-${range[1]} / 共 ${total} 行，每页 30 条`,
                            }}
                            onChange={page => this.loadTableData(page.current, 30)}
                        />
                    </div>
                </div>
            </Drawer>
        )
    }

    renderAdminModals = () => {
        const {
            users,
            mysqlConnections,
            appCreateVisible,
            appCreating,
            connectionManageVisible,
            connectionEditVisible,
            connectionSaving,
            editingConnection,
        } = this.state
        const enabledConnections = mysqlConnections.filter(item => item.status === 'enabled')
        return (
            <>
                <Modal
                    title="新建 Vibe 应用"
                    visible={appCreateVisible}
                    okText="创建"
                    confirmLoading={appCreating}
                    onOk={this.submitCreateApp}
                    onCancel={() => this.setState({ appCreateVisible: false })}
                    destroyOnClose
                >
                    <Form ref={this.appFormRef} layout="vertical">
                        <Form.Item label="所属用户" name="ownerUserId" rules={[{ required: true, message: '请选择所属用户' }]}>
                            <Select showSearch optionFilterProp="children" placeholder="选择用户">
                                {users.map(item => (
                                    <Option key={this.getUserValue(item)} value={this.getUserValue(item)}>
                                        {this.getUserLabel(item)}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="项目名称"
                            name="projectName"
                            rules={[
                                { required: true, message: '请输入项目名称' },
                                { pattern: /^[a-z0-9](?:[a-z0-9-]{0,62}[a-z0-9])?$/, message: '只能使用小写字母、数字和短横线，最长64位' },
                            ]}
                        >
                            <Input placeholder="例如 sales-report" maxLength={64} />
                        </Form.Item>
                        <Form.Item label="项目简介" name="description">
                            <Input.TextArea rows={3} maxLength={500} placeholder="填写应用用途和业务范围" />
                        </Form.Item>
                        <Form.Item label="项目类型" name="deploymentMode" rules={[{ required: true, message: '请选择项目类型' }]}>
                            <Radio.Group buttonStyle="solid">
                                <Radio.Button value="server">服务器部署</Radio.Button>
                                <Radio.Button value="local">仅本地运行</Radio.Button>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item label="主体" name="businessSubject" rules={[{ required: true, message: '请选择主体' }]}>
                            <Radio.Group buttonStyle="solid">
                                <Radio.Button value="lechun">乐纯</Radio.Button>
                                <Radio.Button value="superbody">超体</Radio.Button>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item label="数据库连接" name="mysqlConnectionId" rules={[{ required: true, message: '请选择数据库连接' }]}>
                            <Select placeholder="选择数据库连接">
                                {enabledConnections.map(item => (
                                    <Option key={item.id} value={item.id}>
                                        {item.connectionName}（{item.mysqlHost}:{item.mysqlPort}）
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="数据库名"
                            name="mysqlDatabaseName"
                            rules={[
                                { required: true, message: '请输入数据库名' },
                                { pattern: /^[a-z0-9_-]{1,64}$/, message: '只能使用小写字母、数字、下划线和中划线，最长64位' },
                            ]}
                        >
                            <Input placeholder="例如 vibe_sales_report" maxLength={64} />
                        </Form.Item>
                        <Form.Item name="skipDatabaseCreation" valuePropName="checked">
                            <Checkbox>跳过创建数据库（默认数据库已存在）</Checkbox>
                        </Form.Item>
                    </Form>
                </Modal>

                <Modal
                    title="数据库连接"
                    visible={connectionManageVisible}
                    width={1000}
                    footer={<Button onClick={() => this.setState({ connectionManageVisible: false })}>关闭</Button>}
                    onCancel={() => this.setState({ connectionManageVisible: false })}
                >
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
                        <Button type="primary" icon={<PlusOutlined />} onClick={this.openCreateConnection}>新增连接</Button>
                    </div>
                    <Table
                        rowKey="id"
                        size="small"
                        dataSource={mysqlConnections}
                        pagination={false}
                        columns={[
                            { title: '名称', dataIndex: 'connectionName', width: 150 },
                            {
                                title: '类型',
                                dataIndex: 'databaseType',
                                width: 110,
                                render: value => value === 'analyticdb' ? <Tag color="blue">AnalyticDB</Tag> : <Tag>MySQL</Tag>,
                            },
                            { title: '查询地址', key: 'address', render: (_, item) => `${item.mysqlHost}:${item.mysqlPort}` },
                            {
                                title: '授权地址',
                                key: 'provisionAddress',
                                render: (_, item) => item.provisionHost
                                    ? `${item.provisionHost}:${item.provisionPort || item.mysqlPort}`
                                    : <Text type="secondary">同查询地址</Text>,
                            },
                            { title: '数据库', dataIndex: 'connectionDatabase', width: 140 },
                            { title: '状态', dataIndex: 'status', width: 90, render: value => <Tag color={value === 'enabled' ? 'success' : 'default'}>{value === 'enabled' ? '启用' : '禁用'}</Tag> },
                            { title: '备注', dataIndex: 'remark', render: value => value || '-' },
                            { title: '操作', width: 90, render: (_, item) => <Button size="small" onClick={() => this.openEditConnection(item)}>编辑</Button> },
                        ]}
                    />
                </Modal>

                <Modal
                    title={editingConnection ? '编辑数据库连接' : '新增数据库连接'}
                    visible={connectionEditVisible}
                    okText="保存"
                    width={720}
                    confirmLoading={connectionSaving}
                    onOk={this.saveConnection}
                    onCancel={() => this.setState({ connectionEditVisible: false })}
                    footer={[
                        <Button key="cancel" onClick={() => this.setState({ connectionEditVisible: false })}>取消</Button>,
                        <Button key="save" type="primary" loading={connectionSaving} onClick={this.saveConnection}>保存</Button>,
                    ]}
                    destroyOnClose
                >
                    {/* 2026-07-21 coder(lq): The destroyed modal form must receive values when it mounts, not before. */}
                    <Form
                        key={editingConnection?.id || 'new-connection'}
                        ref={this.connectionFormRef}
                        layout="vertical"
                        initialValues={editingConnection || { databaseType: 'mysql', mysqlPort: 3306, status: 'enabled' }}
                    >
                        <Form.Item label="连接名称" name="connectionName" rules={[{ required: true, message: '请输入连接名称' }]}>
                            <Input maxLength={128} placeholder="例如 生产 Vibe MySQL" />
                        </Form.Item>
                        <Form.Item label="数据库类型" name="databaseType" rules={[{ required: true, message: '请选择数据库类型' }]}>
                            <Select>
                                <Option value="mysql">标准 MySQL</Option>
                                <Option value="analyticdb">阿里云 AnalyticDB for MySQL</Option>
                            </Select>
                        </Form.Item>
                        <Space size={12} style={{ display: 'flex' }} align="start">
                            <Form.Item label="查询连接" name="mysqlHost" rules={[{ required: true, message: '请输入查询连接' }]} style={{ flex: 1 }}>
                                <Input placeholder="mysql.example.com" />
                            </Form.Item>
                            <Form.Item label="查询端口" name="mysqlPort" rules={[{ required: true, message: '请输入查询端口' }]}>
                                <InputNumber min={1} max={65535} style={{ width: 130 }} />
                            </Form.Item>
                        </Space>
                        <Space size={12} style={{ display: 'flex' }} align="start">
                            <Form.Item
                                label="授权连接（可选）"
                                name="provisionHost"
                                rules={[{ pattern: /^[A-Za-z0-9._-]{1,191}$/, message: '授权连接格式不正确' }]}
                                style={{ flex: 1 }}
                            >
                                <Input allowClear placeholder="可写主库地址；为空时沿用查询连接" />
                            </Form.Item>
                            <Form.Item label="授权端口（可选）" name="provisionPort">
                                <InputNumber min={1} max={65535} placeholder="同查询端口" style={{ width: 130 }} />
                            </Form.Item>
                        </Space>
                        <Space size={12} style={{ display: 'flex' }} align="start">
                            <Form.Item
                                label="数据库"
                                name="connectionDatabase"
                                rules={[
                                    { pattern: /^[a-z0-9_-]{1,64}$/, message: '只能使用小写字母、数字、下划线和中划线，最长64位' },
                                ]}
                                style={{ flex: 1 }}
                            >
                                <Input placeholder="选填，例如 vibe-ops" />
                            </Form.Item>
                            <Form.Item label="状态" name="status" rules={[{ required: true }]} style={{ width: 130 }}>
                                <Select><Option value="enabled">启用</Option><Option value="disabled">禁用</Option></Select>
                            </Form.Item>
                        </Space>
                        <Form.Item label="备注" name="remark">
                            <Input.TextArea rows={2} maxLength={500} />
                        </Form.Item>
                    </Form>
                </Modal>
            </>
        )
    }

    renderPromptTemplateModal = () => {
        const {
            promptTemplateVisible,
            promptTemplateLoading,
            promptTemplateSaving,
            promptTemplateText,
            promptTemplateCustomized,
        } = this.state
        return (
            <Modal
                title="维护问数提示词"
                visible={promptTemplateVisible}
                width={960}
                confirmLoading={promptTemplateSaving}
                onOk={this.savePromptTemplate}
                onCancel={() => this.setState({ promptTemplateVisible: false })}
                destroyOnClose
                footer={[
                    <Button
                        key="reset"
                        disabled={promptTemplateLoading || !promptTemplateCustomized}
                        onClick={this.resetPromptTemplate}
                    >
                        恢复默认
                    </Button>,
                    <Button key="cancel" onClick={() => this.setState({ promptTemplateVisible: false })}>取消</Button>,
                    <Button key="save" type="primary" loading={promptTemplateSaving} onClick={this.savePromptTemplate}>保存</Button>,
                ]}
            >
                <Alert
                    type="info"
                    showIcon
                    style={{ marginBottom: 12 }}
                    message="这里维护的是所有数据库授权账号共用的问数提示词模板。账号对应的应用范围和数据字典会在授权管理中生成提示词时自动加入。"
                />
                <Input.TextArea
                    value={promptTemplateText}
                    rows={26}
                    disabled={promptTemplateLoading}
                    onChange={e => this.setState({ promptTemplateText: e.target.value })}
                    style={{ fontFamily: 'Menlo, Monaco, Consolas, monospace', fontSize: 13, lineHeight: 1.6 }}
                />
            </Modal>
        )
    }

    renderProjectPromptModal = () => {
        const {
            projectPromptVisible,
            projectPromptLoading,
            projectPromptName,
            projectPromptMode,
            projectPromptText,
        } = this.state
        const serverDeployment = projectPromptMode === 'server'
        const panelTitle = serverDeployment ? '服务器部署项目提示词' : '仅本地运行项目提示词'
        const panelHint = serverDeployment
            ? '（我的系统有页面，要给别人看，选这个）'
            : '（项目只在本机运行，不发布到服务器）'
        return (
            <Modal
                title={`项目初始化提示词：${projectPromptName}`}
                visible={projectPromptVisible}
                width={900}
                footer={<Button onClick={() => this.setState({ projectPromptVisible: false })}>关闭</Button>}
                onCancel={() => this.setState({ projectPromptVisible: false })}
                destroyOnClose
            >
                <Spin spinning={projectPromptLoading}>
                    {projectPromptText ? (
                        <Collapse bordered={false} defaultActiveKey={['project-prompt']}>
                            <Panel
                                key="project-prompt"
                                header={(
                                    <span>
                                        <CopyOutlined /> {panelTitle}
                                        <Text type="secondary" style={{ marginLeft: 6 }}>{panelHint}</Text>
                                    </span>
                                )}
                            >
                                <Button
                                    type="primary"
                                    icon={<CopyOutlined />}
                                    style={{ marginBottom: 12 }}
                                    onClick={this.copyProjectPrompt}
                                >
                                    复制提示词
                                </Button>
                                <pre style={{ whiteSpace: 'pre-wrap', background: '#f7f8fa', padding: 16, marginBottom: 0, maxHeight: '60vh', overflow: 'auto' }}>
                                    {projectPromptText}
                                </pre>
                            </Panel>
                        </Collapse>
                    ) : (
                        <Text type="secondary">当前应用暂无初始化提示词</Text>
                    )}
                </Spin>
            </Modal>
        )
    }

    render() {
        const {
            dataSource, pagination, loading, keyword, status, batchSyncing, dingdingDeptId, dingdingDepartments,
        } = this.state
        return (
            <div style={{ padding: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                    <Space wrap>
                        <Input
                            allowClear
                            prefix={<SearchOutlined />}
                            placeholder="搜索应用、用户、数据库"
                            value={keyword}
                            onChange={e => this.setState({ keyword: e.target.value })}
                            onPressEnter={() => this.loadList(1)}
                            style={{ width: 260 }}
                        />
                        <Select
                            allowClear
                            placeholder="按状态查询"
                            value={status}
                            onChange={value => this.setState({ status: value }, () => this.loadList(1))}
                            style={{ width: 140 }}
                        >
                            <Option value="approved">待部署</Option>
                            <Option value="provisioning">接入中</Option>
                            <Option value="ready">已就绪</Option>
                            <Option value="failed">失败</Option>
                            <Option value="disabled">禁用</Option>
                        </Select>
                        <Select
                            allowClear
                            showSearch
                            optionFilterProp="children"
                            placeholder="按钉钉部门分类"
                            value={dingdingDeptId}
                            onChange={value => this.setState({ dingdingDeptId: value }, () => this.loadList(1))}
                            style={{ width: 240 }}
                        >
                            {dingdingDepartments.map(item => (
                                <Option key={item.dingdingDeptId} value={item.dingdingDeptId}>
                                    {item.dingdingDeptName}
                                </Option>
                            ))}
                        </Select>
                        <Button type="primary" icon={<SearchOutlined />} onClick={() => this.loadList(1)}>查询</Button>
                        <Button icon={<FileTextOutlined />} loading={batchSyncing} onClick={this.syncAllDatabaseReadme}>
                            批量同步数据字典
                        </Button>
                        <Button type="primary" icon={<PlusOutlined />} onClick={this.openCreateApp}>新建应用</Button>
                        <Button icon={<SettingOutlined />} onClick={() => this.setState({ connectionManageVisible: true })}>
                            数据库连接
                        </Button>
                    </Space>
                </div>
                <Table
                    rowKey="id"
                    size="middle"
                    loading={loading}
                    dataSource={dataSource}
                    columns={this.renderColumns()}
                    scroll={{ x: 2140 }}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: total => `共 ${total} 个应用`,
                    }}
                    onChange={page => this.loadList(page.current, page.pageSize)}
                />
                <VibeAppDetailDrawer
                    visible={this.state.detailVisible}
                    projectId={this.state.detailProjectId}
                    onClose={() => this.setState({ detailVisible: false })}
                    onUpdated={() => this.loadList()}
                />
                {this.renderDataDrawer()}
                {this.renderAdminModals()}
                {this.renderPromptTemplateModal()}
                {this.renderProjectPromptModal()}
            </div>
        )
    }
}
